module.exports = __webpack_public_path__ + "static/media/rotate-cw.e3f08426.svg";